// src/pages/dashboards/AdminDashboard.jsx
// Admin layout: configures the nav and renders nested routes via DashboardLayout.

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { BarChart3, Users, Building2, Ticket, Receipt } from "../../components/icons";

// placeholder pages (will be built out)
import AdminOverview from "./admin/AdminOverview";
import AdminUsers from "./admin/AdminUsers";
import AdminCompanies from "./admin/AdminCompanies";
import AdminVouchers from "./admin/AdminVouchers";
import AdminPayments from "./admin/AdminPayments";

const NAV = [
  { label: "Overview", path: "/admin", icon: BarChart3 },
  { label: "Users", path: "/admin/users", icon: Users },
  { label: "Companies", path: "/admin/companies", icon: Building2 },
  { label: "Payments", path: "/admin/payments", icon: Receipt },
  { label: "Vouchers", path: "/admin/vouchers", icon: Ticket },
];

export default function AdminDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout nav={NAV} />}>
        <Route index element={<AdminOverview />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="companies" element={<AdminCompanies />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="vouchers" element={<AdminVouchers />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}